export function ArtworkDetailMembershipAdUnit(props: {
  className?: string
  imgClassName?: string
}) {
  return null
  // const { t } = useTranslation(['growth'])
  // const { display, variant } = useModelTrialAdUnitStyleType({
  //   type: 'in-detail',
  // })
  // if (!display) return null
  // return (
  //   <Link
  //     to="/membership/plans"
  //     className={props.className}
  //     onClick={() => {
  //       const trackingLocation = 'artwork-in-detail-ad-unit'
  //       track('enter_member_click', {
  //         location: trackingLocation,
  //       })
  //       startEventGroup('member_source', trackingLocation, {
  //         persistent: true,
  //       })

  //       // Scroll to top after navigation
  //       setTimeout(() => {
  //         window.scrollTo(0, 0)
  //       }, 100)
  //     }}
  //   >
  //     <img
  //       loading="lazy"
  //       className={props.imgClassName}
  //       src={t(`growth:ad-unit.membership.in-detail-${variant}.image-url`)}
  //     />
  //   </Link>
  // )
}
